import { render, staticRenderFns } from "./BiLayout.vue?vue&type=template&id=4fd0bd7c"
import script from "./BiLayout.vue?vue&type=script&lang=js"
export * from "./BiLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports